import MainList from "./MainList"

const MainView = () => {

    return (
        <MainList />
    )
}

export default MainView